import { BaseRepository } from "@/repositories/base-repository"
import { type IPurchase } from "@/interfaces/api/purchase.interface"
import type { Moment } from "moment"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import type { PurchaseItem } from "@/models/purchase-item.model"

export class PurchaseRepository extends BaseRepository<IPurchase> {
  protected resourcePath = "administration/purchases"

  public async applyPricesRetroactively(purchaseItem: PurchaseItem, retroactiveDate: Moment) {
    return new HTTPRequestBuilder(
      HTTPMethods.PUT,
      `${this.resourcePath}/apply-prices-retroactively/`
    )
      .setData({
        purchase_item_id: purchaseItem.id,
        retroactive_date: retroactiveDate.format("YYYY-MM-DD")
      })
      .build()
      .execute()
  }
}
